const currentDate = new Date()
const currentYear = currentDate.getFullYear()

export const HOLIDAY_START_DATE = new Date(
  Date.UTC(currentYear, 8, 25, 0, 0, 0)
)

export const HOLIDAY_END_DATE = new Date(
  Date.UTC(currentYear, 9, 25, 0, 0, 0)
)
